{
  "title": "Subscriptions",
  "paginationTitle": "subscriptions",
  "columns": {
    "name": "Name",
    "description": "Descriptions",
    "senders": "Notification methods",
    "sender": "Sender",
    "actions": "Actions",
    "filter": "Filter",
    "integrationPoint": "Integration point",
    "chooseIntegrationPoint": "Choose integration point",
    "integrationPoints": "Integration points",
    "event": "Event",
    "events": "Events",
    "chooseEvent": "Choose event",
    "messageTemplate": "Message template",
    "template": "Template",
    "nameFull": "Name",
    "addNameFull": "Add name",
    "type": "type",
    "chooseType": "Choose type",
    "host": "Host",
    "chooseHost": "Choose host",
    "port": "Port",
    "choosePort": "Choose port",
    "path": "Path",
    "addUrl": "Add URL-path",
    "mail": "Email",
    "addMail": "Add email",
    "incorrectMail": "Incorrect email format",
    "subject": "Subject",
    "addSubject": "Add subject",
    "byDefault": "By default",
    "byDefaultDialog": "Make it a default - use template to notificate users"
  },
  "senders": {
    "telegram": "Telegram",
    "email": "Email",
    "bell": "Notification"
  },
  "filter": {
    "or": "OR",
    "and": "AND",
    "cit": "CI Types",
    "hi": "Health Indiactors",
    "values": "Values",
    "hiIndicators": "Health Indiactors types",
    "citAttributes": "CI Attributes"
  },
  "external-services": {
    "configuration": "Configuration",
    "title": "External services",
    "list": "List of services",
    "listEmpty": "List of services is empty",
    "one-service": "External service",
    "subscription": "Subscription",
    "subscriptions": "Subscriptions",
    "integration-points": "Integration points",
    "empty": "Choose ot create external service"
  },
  "success": {
    "delete": "Deleted successfully",
    "add": "Added successfully",
    "upgrade": "Upgraded successfully"
  },
  "template": {
    "list": "List of events",
    "main": "Template",
    "createTemplate": "Create template",
    "choose": "Select template",
    "empty": "Select or add a template",
    "templateTheme": "Template's theme",
    "addTemplateTheme": "Choose the theme of template",
    "type": "Type",
    "chooseType": "Choose the type of template",
    "notificationTool": "Notification tool",
    "result": "Result",
    "templateVariables": "Template variables",
    "checkTemplateValidity": "Check template validity"
  },
  "receivers": {
    "title": "List of receivers",
    "newElement": "New receiver",
    "name": "name",
    "active_time_interval": "Send interval",
    "mute_time_interval": "Mute interval",
    "sender_name": "Sender name",
    "address": "Adress",
    "canals": "Notification sending channels",
    "send_resolve": "Send resolve",
    "sender_active": "Sender active",
    "sender_not_active": "Sender not active"
  },
  "deleteDialog": {
    "title": "Found depending elements:"
  }
}